export const QueryKey = {
	auth: 'auth',
	admins: 'admins',

	attachments: 'attachments',
	companies: 'companies',
	complaints: 'complaints',
	content: 'content',

	users: 'users',

	components: 'components',
	componentVariations: 'component-variations',

	articles: 'articles',
	colorGroups: 'color-groups',
	colors: 'colors',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	investments: 'investments',
	investmentItems: 'investment-items',
	projects: 'projects',
	projectTemplates: 'project-templates',
	productTypes: 'product-types',
	productTypeCategories: 'product-type-categories',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
